import { Component, type ErrorInfo, type ReactNode } from "react";
import { Button } from "@/components/ui/Button";

type Props = { children: ReactNode };
type State = { hasError: boolean; message: string };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, message: "" };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error.message || "Unexpected error" };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[AMOS ErrorBoundary]", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-[50vh] flex-col items-center justify-center gap-3 p-8 text-center">
          <h2 className="text-lg font-semibold text-zinc-900">Something went wrong</h2>
          <p className="max-w-md text-sm text-zinc-500">{this.state.message}</p>
          <Button
            onClick={() => {
              this.setState({ hasError: false, message: "" });
              window.location.assign("/");
            }}
          >
            Back to dashboard
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}
